import { type TimestampShared } from "../../functions/utils/sharedDataTypes";
import { type EntityReference } from "./entityReference";

export interface BaseCourse {
  published: boolean;
  premium: boolean;
  name: string;
  slug: string;
  description: string;
  related_course: EntityReference[];
  main_image: string;
  categories: (keyof typeof CourseCategories)[];
  author: EntityReference;
  date: TimestampShared;
  created_on: TimestampShared;
  updated_on: TimestampShared;
}

export enum CourseCategories {
  "Stressmanagement" = "Stressmanagement",
  "Entspannung" = "Entspannung",
  "Meditation" = "Meditation",
  "Kommunikation" = "Kommunikation",
  "Kinderentspannung" = "Kinderentspannung",
  "Partnerschaft" = "Partnerschaft",
  "Yoga" = "Yoga",
}
